// views/Dashboard/Overview/Overview.tsx
import { useAuth } from '../../../contexts/AuthContext';
import EarningsChart from './components/EarningsChart/EarningsChart';
import FreeTierNotice from './components/FreeTierNotice/FreeTierNotice';
import styles from './Overview.module.css';

const czk = (n: number) => (Number(n) || 0).toLocaleString('cs-CZ');

const Overview = () => {
  const { user } = useAuth();
  if (!user) return null;

  if (user.tier?.name?.toLowerCase() === 'free') {
    return (
      <div className={styles.overview}>
        <h1 className={styles.pageTitle}>Přehled</h1>
        <FreeTierNotice totalDays={60} tier={user.tier} />
      </div>
    );
  }

  const stats = [
    { icon: '💰', label: 'Výdělky na bonusech', value: `${czk(user.bonus_revenue)} Kč`, tour: 'stat-bonus-revenue' },
    { icon: '👥', label: 'Výdělky na doporučeních', value: `${czk(user.referral_revenue)} Kč`, tour: 'stat-referral-revenue' },
    { icon: '🌱', label: 'Odhadovaný výdělek na bonusech', value: `${czk(user.potential_bonus_revenue)} Kč`, tour: 'stat-potential-revenue' },
    { icon: '✅', label: 'Počet dokončených bonusů', value: czk(user.bonus_history_len), tour: 'stat-completed-bonuses' },
  ];

  return (
    <div className={styles.overview}>
      <h1 className={styles.pageTitle}>Přehled</h1>

      <div className={styles.statsGrid}>
        {stats.map((s) => (
          <div className={styles.statCard} key={s.label} data-tour={s.tour}>
            <div className={styles.statIcon}>{s.icon}</div>
            <div className={styles.statContent}>
              <h3>{s.label}</h3>
              <p className={styles.statValue}>{s.value}</p>
            </div>
          </div>
        ))}
      </div>

      <EarningsChart />
    </div>
  );
};

export default Overview;
